import { AsyncPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { delay, of, startWith } from 'rxjs';

import { PrivaLoaderComponent } from '@priva/components/loader';
import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaSpinnerComponent } from '@priva/components/spinner';
import { PrivaTableColumnDirective, PrivaTableComponent } from '@priva/components/table';
import { PrivaLocalizationModule } from '@priva/localization';

import { Container } from '../../models';

@Component({
    selector: 'app-container-list',
    imports: [
        AsyncPipe,
        PrivaLoaderComponent,
        PrivaLocalizationModule,
        PrivaNotificationComponent,
        PrivaSpinnerComponent,
        PrivaTableColumnDirective,
        PrivaTableComponent,
    ],
    templateUrl: './container-list.component.html',
    styleUrl: './container-list.component.scss',
})
export class ContainerListComponent {
    containers = input<Container[]>([]);
    showRemove = input(false);

    containerClick = output<Container>();
    removeContainerClick = output<Container>();

    init$ = of(false).pipe(delay(1), startWith(true));

    onContainerClick(container: Container): void {
        this.containerClick.emit(container);
    }

    onRemoveContainerClick(container: Container): void {
        this.removeContainerClick.emit(container);
    }
}
